import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { app } from './firebase';

// Currency all Stripe charges settle in. Tickets and subscriptions both bill in AUD.
export const REVENUE_CURRENCY = 'AUD';

let _analytics = null;
if (app) {
  isSupported().then(yes => { if (yes) _analytics = getAnalytics(app); }).catch(() => {});
}

// Fire-and-forget GA4 event. No-ops if analytics isn't ready/supported/blocked.
export function track(name, params = {}) {
  // TEMP debug: confirms the event fired client-side even if GA delivery is
  // blocked (e.g. Brave/ad blockers). Remove before the production merge.
  console.debug('[ga]', name, params, _analytics ? 'sent' : 'analytics-not-ready');
  try {
    if (_analytics) logEvent(_analytics, name, params);
  } catch { /* analytics unavailable — ignore */ }
}
